import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ScheduleComponent } from '../detail-view/schedule/schedule.component';
import { CommentsComponent } from './comments/comments.component';
import { DynamicPricingComponent } from './dynamic-pricing/dynamic-pricing.component';
import { EntriesComponent } from './entries/entries.component';
import { InfoComponent } from './info/info.component';
import { LeaderboardComponent } from './leaderboard/leaderboard.component';
import { MultiViewComponent } from './multi-view/multi-view.component';
import { PartnersComponent } from './partners/partners.component';
import { PeopleComponent } from './people/people.component';
import { PrizeComponent } from './prize/prize.component';

const routes: Routes = [
  {
    path: '',
    component: MultiViewComponent,
    children: [
      {
        path: 'info/:info_slug',
        component: InfoComponent
      },
      {
        path: 'partner/:partner_slug',
        component: PartnersComponent
      },
      {
        path: 'pricing/:pricing_slug',
        component: DynamicPricingComponent
      },
      {
        path: 'people/:people_slug',
        component: PeopleComponent
      },
      {
        path: 'award/:prize_slug',
        component: PrizeComponent
      },
      {
        path: 'schedule/:schedule_slug',
        component: ScheduleComponent
      },
      {
        path: 'entries',
        component: EntriesComponent
      },
      {
        path: 'discussions',
        component: CommentsComponent
      },
      {
        path: 'leaderboard',
        component: LeaderboardComponent
      },
      {
        path: '',
        redirectTo: 'info/about'
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DetailViewRoutingModule {}
